import illustrationDesktop from '@/assets/illustrations/industry card construction desktop.svg'
import illustrationMobile from '@/assets/illustrations/industry card construction mobile EXT.svg'

// Full-bleed background hero, same treatment as the shared IndustryHero
// (src/features/industry-page/components/IndustryHero.tsx): absolute-cover
// images behind relatively-positioned text, contained by the page's own
// max-w-content wrapper rather than the viewport. Desktop uses the same
// construction art as the homepage picker; mobile uses the "EXT" export
// (the same one IndustryHero uses) for the extra bottom clearance a
// full-bleed crop needs so the headline doesn't sit on the buildings.
export function Hero() {
    return (
        <section className="relative isolate overflow-hidden">
            <img
                src={illustrationMobile}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover object-top md:hidden"
            />
            <img
                src={illustrationDesktop}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 hidden h-full w-full object-cover md:block"
            />

            <div className="relative flex min-h-[620px] flex-col justify-end p-8 md:aspect-[1281/528] md:min-h-0 md:justify-start lg:p-16">
                {/* Mobile size raised ~20% (28px → 34px) per Charly's ask. Desktop (lg:text-6xl) unchanged. */}
                <h1 className="max-w-2xl text-[34px] font-medium leading-normal text-unimo-slate lg:text-6xl">
                    Come and talk to us at UKCW 2026
                </h1>
                {/* Same size as the "Book a 15-minute chat..." heading below (ExpertCards' h2) — Charly's ask. */}
                <div className="mt-6 font-light text-unimo-slate">
                    <p className="text-2xl lg:text-3xl">29 Sept – 1 Oct 2026</p>
                    <p className="text-2xl lg:text-3xl">Stand K1, Hall 4</p>
                </div>
            </div>
        </section>
    )
}

export default Hero
